export const removeClientId = (navigate, location) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete("clientId");
    navigate(
        {
            pathname: location.pathname,
            search: queryParams.toString(),
        },
        { replace: true }
    );
};
